export default {
  zh: {
    paid: '支付成功',
    price: '支付金额',
    deviceNum: '套餐设备数',
    packageTime: '剩余时长',
    devices: '台',
    days: '天',
    payFailed: '支付失败',
    failedNotice: '请查询相关账户是否已扣款，避免重复操作。',
    sure: '确定',
    contactUs: '如遇支付问题请联系我们，邮箱地址',
    notFindOrder: '订单未找到',
    'D': '天',
    'H': '小时',
    'm': '月',
    '$': 'USD$',
    '￥': '￥'
  },
  en: {
    paid: 'Payment successful',
    price: 'Cost',
    deviceNum: 'Device Limit',
    packageTime: 'Balance',
    devices: 'device |devices',
    days: 'day | days',
    payFailed: 'Payment Failure',
    failedNotice: 'Payment failed, in order to avoid duplicate operation, please check whether your relevant account has been deducted.',
    sure: 'OK',
    contactUs: 'If you have payment problem, please contact customer service via',
    notFindOrder: 'This order does not exist!',
    'D': 'day|days',
    'H': 'hour|hours',
    'm': 'month|months',
    '$': 'USD$',
    '￥': '￥'
  }
}



// WEBPACK FOOTER //
// ./src/components/topup/topUpResult/lang.js